import { render, staticRenderFns } from "./EditReleasesLoader.vue?vue&type=template&id=1a796a2e"
import script from "./EditReleasesLoader.vue?vue&type=script&lang=ts"
export * from "./EditReleasesLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports